/** @type {Partial<import("swr/_internal").PublicConfiguration>} */
export const SWR_CONFIG_FOR_STATIC_DATA = {
  revalidateIfStale: true,
  revalidateOnMount: true,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  keepPreviousData: false,
  dedupingInterval: 0,
  refreshInterval: 0,
};
